module.exports = __webpack_public_path__ + "img/favicon.cf6e3f27.ico";